export default __webpack_public_path__ + "static/media/trovityLogo.403fd3a4.svg";